import { useTranslation } from 'react-i18next'

import useChatRoomLogic from 'features/Chat/hocs/useChatRoomLogic'
import { useCurrentUser } from 'store/api/yay/user'

import Button from '../Button'
import { UserList } from './UserList'

export const HimanowUserList = ({ mode = 'grid', ...props }: UserList) => {
  const { t } = useTranslation()

  const { onCreateChatRoom } = useChatRoomLogic()

  const { data: currentUser } = useCurrentUser()

  return (
    <UserList
      mode={mode}
      actionButton={
        mode === 'list'
          ? (user) => {
              // We need to use a separate `onCreateChatRoom`, or else
              // all buttons will share `onCreateChatRoomIsLoading`.
              const {
                onCreateChatRoom: _onCreateChatRoom,
                onCreateChatRoomIsLoading: _onCreateChatRoomIsLoading,
              } = useChatRoomLogic()

              if (user?.id === currentUser?.id) return null

              return (
                <Button
                  loading={_onCreateChatRoomIsLoading}
                  icon="chat"
                  buttonStyle="secondary"
                  onClick={() =>
                    _onCreateChatRoom({
                      userId: user.id,
                      goBack: true,
                      isHimaChat: true,
                      from: 'himanow',
                    })
                  }
                >
                  {t('common.chat_now')}
                </Button>
              )
            }
          : undefined
      }
      showBio
      {...props}
      onClick={
        mode !== 'list'
          ? (user, e) => {
              e.preventDefault()

              onCreateChatRoom({
                userId: user.id,
                goBack: true,
                isHimaChat: true,
                from: 'himanow',
              })
            }
          : undefined
      }
    />
  )
}
